// function to render a row. Takes the following props:
// - item: item the row represents
// - claimItemHandler: callback to claim an item
// - unclaimItemHandler: callback to unclaim an item
// - deleteItemHandler: callback to delete an item

import { useState } from "react";
import { patchItem } from "../api/Api";

function Row(props) {

  // ---------------------------------------------------------------- state and hooks

  const [isEditing, setIsEditing] = useState(false);
  const [name, setName] = useState(props.item.name);
  const [editedName, setEditedName] = useState(props.item.name);
  const [details, setDetails] = useState(props.item.details || '');
  const [editedDetails, setEditedDetails] = useState(props.item.details || '');

  const currentUser = sessionStorage.getItem('user');
  const isClaimed = props.item.claimerNames?.includes(currentUser);

  // ---------------------------------------------------------------- logic

  function toggleClaimHandler() {
    if (isClaimed) {
      props.unclaimItemHandler()
    } else {
      props.claimItemHandler();
    }
  }

  async function saveChanges() {
    setIsEditing(false);

    const updatesObj = {
      name: editedName,
      details: editedDetails,
    };
    await patchItem(props.item.id, updatesObj).then((result) => {
      setName(result.name);
      setDetails(result.details);
    });
  }

  function discardChanges() {
    setIsEditing(false);
    setEditedName(name);
    setEditedDetails(details);
  }

  // ---------------------------------------------------------------- render

  let rowBody;

  if (currentUser !== props.item.creatorName) {
    // if not created by the current user, return a simple claimable/unclaimable row
    rowBody = (
      <>
        {/* {props.isClaimRow ? <td>{props.item.askerName}</td> : <></>} */}
        <td>{props.item.name}</td>
        <td>{props.item.details || ''}</td>
        <td>
          {genClaimers()}
          <button onClick={toggleClaimHandler}>{isClaimed ? "Unclaim" : "Claim"}</button>
        </td>
      </>
    );
  } else if (isEditing) {
    // if created by current user and editing, return row with edit fields
    rowBody = (
      <>
        {/* {props.isClaimRow ? <td>{props.item.askerName}</td> : <></>} */}
        <td style={{ width: '30%' }}>
          <input
            style={{ width: 'calc(100% - 10px)', marginLeft: '0px' }}
            maxLength={50}
            value={editedName}
            onChange={(event) => setEditedName(event.target.value)}
          />
        </td>
        <td style={{ width: '60%' }}>
          <textarea
            style={{ width: 'calc(100% - 10px)' }}
            value={editedDetails}
            onChange={(event) => setEditedDetails(event.target.value)}
            rows={10}
          />
        </td>
        <td style={{ width: '10%' }}>
          <div>
            <button
              style={{ marginBottom: '10px' }}
              onClick={saveChanges}>
              Save
            </button>
          </div>
          <div>
            <button onClick={discardChanges}>Cancel</button>
          </div>
        </td>
      </>
    );
  } else {
    rowBody = (
      // if created by current user and not editing, return row with full edit options
      <>
        {/* {props.isClaimRow ? <td style={{ width: '10%' }}>{props.item.askerName}</td> : <></>} */}
        <td style={{ width: '30%', wordBreak: 'break-word' }}>{name}</td>
        <td style={{ width: '60%' }}>{details || ''}</td>
        <td style={{ width: '10%' }}>
          {genClaimers()}
          <select value="Actions" readOnly={true}>
            <option disabled={true} value="Actions">Actions</option>
            {props.item.askerName == currentUser ?
              <></> :
              <option onClick={toggleClaimHandler}>
                {isClaimed ? "Unclaim" : "Claim"}
              </option>}
            <option onClick={() => setIsEditing(true)}>Edit</option>
            <option onClick={props.deleteItemHandler}>Delete</option>
          </select>
        </td>
      </>
    );
  }

  return (
    <tr 
    style={{ backgroundColor: isClaimed && !props.isClaimRow ? 'rgba(1, 1, 1, 0.1)' : 'white' }}>
      {rowBody}
    </tr>
  )

  // ---------------------------------------------------------------- helpers

  function genClaimers() {
    let claimers = props.item.claimerNames
      ?.sort()
      .map(claimer => (
        <div key={claimer} style={{ marginBottom: '5px' }}>{claimer}</div>
      ));

    return (
      <div>
        {claimers}
      </div>
    );
  }
}

export default Row;